const options = {
    rootClass: 'zp-grid',
    initType: 1
};

LoaderFactory(options, (function (w, d, $, undefined) {

    const _w = $(w);
    const _d = $(d);

    class Grid {

        constructor (root) {
            this.start(root);
        }

        start (root) {
            this.initIsotope(root);
        }

        initIsotope (root) {

            let _root = $(root);
            let gridElements = $('#' + root.attr('id') + ' .zp-grid-element');

            let maxColumns = parseInt(_root.attr('data-max-columns'));
            let columnWidth = parseInt(_root.attr('data-column-width'));

            gridElements.css('width', columnWidth+'px');

            $('#' + root.attr('id') + ' .zp-grid_grid').isotope({
                itemSelector: '.grid-item',
                masonry: {
                    columnWidth: columnWidth,
                    isFitWidth: true
                }
            });

            this.visibleElements(root);

        }

        visibleElements (root) {

            let gridElements = $('#' + root.attr('id') + ' .zp-grid-element');

            let delay;
            gridElements.each((index, element) => {

                delay = index*80;
                let _element = $(element);
                _element.css('transition-delay', delay+'ms');
                _element.addClass('visible');

            });

        }

    }

    return Grid;

}(window, document, jQuery)));